export default __webpack_public_path__ + "static/media/sounds/clic_continuare_2021.mp3";